import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getNotification } from "../../../../shared/hooks/useFetchNotifications";
import API_URLS from "../../Utils/axr";
import { errorConditionGTM } from "../../Utils/googleTags";
import store from "../store";

export interface Reward {
  id: number;
  rewardName: string;
  rewardType: string;
  rewardAmount: string;
  rewardEligibleDate: string | null;
  rewardRedemptionDate: string | null;
  rewardExpirationDate: string | null;
  rewardStatus: string;
  rewardPriority: string;
  priorityId: string;
  notificationRank: number;
  rewardTimelineDays: number;
}

const initialState = {
  myRewardsData: [] as Reward[],
  loading: false,
};

export const getMyRewards = createAsyncThunk(
  "myRewards/getMyRewards",
  async (): Promise<Reward[]> => {
    const reduxStore = store.getState();
    const headers = reduxStore?.brightspeedToken?.headers;
    const ban = reduxStore?.user?.loginUserBan;

    if (!ban) {
      throw new Error("Billing account number is unavailable");
    }

    const response = await getNotification(
      {
        "": [`${API_URLS?.myRewardsUrl}?ban=${encodeURIComponent(ban)}`],
      },
      headers
    );
    const rewards: Reward[] = response?.data?.myRewards;
    if (!Array.isArray(rewards)) {
      throw new Error("Invalid rewards API response");
    }
    return rewards;
  },
  {
    condition: (): boolean => !store.getState()?.myRewards?.loading,
  }
);

const myRewardsSlice = createSlice({
  name: "myRewards",
  initialState,
  reducers: {
    clearMyRewards: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(getMyRewards.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getMyRewards.fulfilled, (state, action) => {
      state.myRewardsData = action.payload;
      state.loading = false;
    });
    builder.addCase(getMyRewards.rejected, (state, action) => {
      errorConditionGTM(
        "BRSPD_Fiber_EC_Flow",
        "my rewards",
        action.error?.message,
        action.type
      );
      state.myRewardsData = [];
      state.loading = false;
    });
  },
});

export const { clearMyRewards } = myRewardsSlice.actions;
export default myRewardsSlice.reducer;